<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-layout
          row
          wrap
          flat
          style="z-index: 3"
          class="white shadow justify-center align-center py-2 px-3"
        >
          <v-autocomplete
            outline
            singleLine
            hideDetails
            autocomplete
            item-value="id"
            item-text="name"
            @change="initData"
            :disabled="loading"
            v-model="branch_id"
            :items="branch_filters"
            style="max-width: 300px"
            :placeholder="$t('branch')"
            v-if="userCan('view_all_branches_report')"
          />
          <v-spacer class="hidden-sm-and-down" />

          <v-date
            singleLine
            @input="initData"
            :clearable="false"
            v-model="end_date"
            :disabled="loading"
            :hideDetails="true"
            format="YYYY-MM-DD"
            class="hide-details"
            value-type="YYYY-MM-DD"
            style="max-width: 300px"
            input_id="start_date_ana"
            :placeholder="$t('end_date')"
          />
          <v-btn
            icon
            flat
            medium
            @click="initData"
            :loading="loading"
            color="grey darken-2"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-layout>
        <balance-table
          :title="title"
          :rates="mapped_rates"
          :currencies="currencies"
          :accounts="all_accounts"
          :brnch_name="selectedBranch.name"
        />
        <!-- <rate-table
          @reload="initData"
          :rates="rates"
          :date="end_date"
          class="flex xs12 sm5"
        ></rate-table> -->

        <!-- <customer-accounts
          :external="true"
          :currencies="currencies"
          :customers="stock"
          :title="$t('stock')"
        />-->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { customersMixin } from "@/mixins/index.js";
import balanceTable from "./balanceTable.vue";
// import RateTable from "./RateTable.vue";

export default {
  name: "income-statment",
  components: { balanceTable },
  mixins: [customersMixin],
  data: () => ({
    rates: [],
    branch_id: "",
    loading: true,
    all_accounts: [],
    mapped_rates: {},
    branch_filters: [],
    end_date: new Date().toLocaleDateString("en-ca"),
  }),

  computed: {
    currencies() {
      return this.initialData.currencies;
    },
    title() {
      return `${this.$t("balance_sheet_of")} ( ${
        this.end_date
      } - ${this.persianDateFilter(this.end_date, true)})`;
    },
    selectedBranch: (vm) =>
      vm.branch_filters.find((x) => x.id == vm.branch_id) || {},
  },

  methods: {
    async ratesUpdated() {
      await this.initData();
      this.$refs.summery.save();
    },

    getBranches() {
      this.axios.get("branches").then((res) => {
        this.branch_filters = res.data;
      });
    },

    async initData() {
      this.loading = true;
      await this.axios
        .get(
          `reports?company_report=true&balance_sheet=true&end_date=${this.end_date}&branch_id=${this.branch_id}`
        )
        .then(async (res) => {
          this.rates = res.data.rates;
          this.mapped_rates = res.data.mapped_rates;
          let accounts = Object.keys(res.data.accounts).map(
            (k) => res.data.accounts[k]
          );
          this.all_accounts = accounts.filter((x) => x.type != "stock");
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  created() {
    this.branch_id = this.userBranch.id;
    this.initData();
    this.getBranches();
    this.getCustomers();
  },
};
</script>
